module.exports = __webpack_public_path__ + "img/ASpace.57b7ea3e.png";